import { Component, OnInit, ViewChild } from '@angular/core';
import { AuditLogsService } from '@data/auditReports/audit-logs.service';
import { LoadPanelOption } from '@shared/common-components/load-panel/load-panel.component';
import { CommonDataService } from '@shared/services/common-data.service';
import { NotificationService } from '@shared/services/notification.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';

interface ChgPriorActivityLogs{
  entityName:string|null;
  title:string|null;
  fieldName:string|null;
  previousValue:string|null;
  currentValue:string|null;
  weekendingDate:Date|string|null;
  modifiedDate:Date|string|null;
  modifiedBy:string;
  modifiedByUser:string;
}

@Component({
    selector: 'app-change-prior-tracker',
    templateUrl: './change-prior-tracker.component.html',
    styleUrls: ['./change-prior-tracker.component.less'],
    standalone: false
})
export class ChangePriorTrackerComponent implements OnInit {

  loadingData=true;

  showLoadPanel=false;
  loadPanelOption:LoadPanelOption={
    closeOnOutsideClick:false,
    message:"loading...",
    visible:true,
    showPane:true,
    ofPosition:'#changePriorTrackerGrid',
    shadingColor:'rgba(0,0,0,0.05)'
  };

  changePriorTrackerList:ChgPriorActivityLogs[]=[];

  displayColumns = [
    
    { caption: 'Entity', dataField: 'entityName', dataType: 'string', format: "", cellTemplate:null, width: "15%"},
    { caption: 'Title', dataField: 'title', dataType: 'string', format: "", cellTemplate:null, width: "30%"},
    { caption: 'Weekending Date', dataField: 'weekendingDate', dataType: 'date', format: "MM/dd/yy", cellTemplate:null, width: "12%"},
    { caption: 'Line Item', dataField: 'fieldName', dataType: 'string', format: "", cellTemplate:null, width: "10%"},
    { caption: 'Previous Value', dataField: 'previousValue', dataType: 'string', format: "", cellTemplate:'numberTemplate', width: "8%"},
    { caption: 'Current Value', dataField: 'currentValue', dataType: 'string', format: "", cellTemplate:'numberTemplate', width: "7%"},
    { caption: 'Modified On', dataField: 'modifiedDate', dataType: 'date', format: "MM/dd/yy, HH:mm aa", cellTemplate:null, width: "8%"}, 
    { caption: 'Modified By', dataField: 'modifiedByUser', dataType: 'string', format: "", cellTemplate:null, width: "10%"}  
  ];

    @ViewChild('changePriorTrackerGrid') grid: DxDataGridComponent;

  constructor(private _aud: AuditLogsService, private commonServices: CommonDataService, private _notify: NotificationService) {
    this.fetchChgPriorActivityData();
   }

  ngOnInit(): void {
  }

  fetchChgPriorActivityData(){
    if(!this.loadingData)
      this.showLoadPanel=true;
    this._aud.getChangePriorActivityData().subscribe(
      r=>{
        if(r.status=="SUCCESS"){
          if(r.serviceResult)
            this.changePriorTrackerList=r.serviceResult;
          else
            this.changePriorTrackerList=[];
          this.showLoadPanel=false;
          this.loadingData=false;
        }
      }
    );
  }

    onExporting(e:any) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Change Prior Tracker');
  
      exportDataGrid({
        component: this.grid.instance,
        worksheet: worksheet,
        autoFilterEnabled: true
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ChangePriorTracker.xlsx');
        });
      });
      e.cancel = true;
    }
  

}
